/** Target-month pills: one colour per month (user-chosen palette). Each pair meets 4.5:1 contrast. */
export interface MonthInfo {
  /** 1-12 */
  n: number;
  short: string;
  long: string;
  /** Pill background. */
  color: string;
  /** Pill text. */
  text: string;
}

const WHITE = '#ffffff';

export const MONTHS: readonly MonthInfo[] = [
  { n: 1, short: 'Jan', long: 'January', color: '#1d4ed8', text: WHITE }, // blue
  { n: 2, short: 'Feb', long: 'February', color: '#7dd3fc', text: '#0c4a6e' }, // light blue
  { n: 3, short: 'Mar', long: 'March', color: '#86efac', text: '#14532d' }, // light green
  { n: 4, short: 'Apr', long: 'April', color: '#f9a8d4', text: '#831843' }, // pink
  { n: 5, short: 'May', long: 'May', color: '#14532d', text: WHITE }, // dark green
  { n: 6, short: 'Jun', long: 'June', color: '#a21caf', text: WHITE }, // magenta
  { n: 7, short: 'Jul', long: 'July', color: '#fde047', text: '#713f12' }, // yellow
  { n: 8, short: 'Aug', long: 'August', color: '#dc2626', text: WHITE }, // red
  { n: 9, short: 'Sep', long: 'September', color: '#ca8a04', text: '#1c1917' }, // dark yellow
  { n: 10, short: 'Oct', long: 'October', color: '#f97316', text: '#431407' }, // orange
  { n: 11, short: 'Nov', long: 'November', color: '#78350f', text: WHITE }, // brown
  { n: 12, short: 'Dec', long: 'December', color: '#7e22ce', text: WHITE }, // purple
];

export function monthInfo(n: number | null | undefined): MonthInfo | null {
  return n === null || n === undefined ? null : MONTHS.find((m) => m.n === n) ?? null;
}
